import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { images } from '../../../../assets';
import * as s from './styled-produto';

const ProdutoDetail = () => {
  const { title } = useContext(ThemeContext);
  return (
    <s.Container>
      <s.InfoContainer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <s.Medicao>Pressão de alimentação</s.Medicao>
          <s.ValueContainer title={title}>
            <s.Value title={title}>1500,00 kWh</s.Value>
          </s.ValueContainer>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <s.Medicao>Pressão de alimentação</s.Medicao>
          <s.ValueContainer title={title}>
            <s.Value title={title}>1500,00 kWh</s.Value>
          </s.ValueContainer>
        </div>
      </s.InfoContainer>
      <s.ImageContainer>
        <s.Line id="line" src={images.LeftLine} />
        <s.ProdutoImage src={images.ProdutoDefault} width="50%" height="20vh" />
        <s.Line id="line" src={images.RightLine} />
      </s.ImageContainer>
    </s.Container>
  );
};

export default ProdutoDetail;
